<template>
  <base-dialog
    data-testid="endingSubscriptionDialog.dialog"
    dialog-id="endingSubscriptionDialog"
    width="500px"
    :cancelable="true"
    :banner="true"
    :title="'Your trial is ending soon!'"
    @complete-dialog="upgrade"
    @cancel-dialog="remindLater"
  >
    <template #subHeader>
      <div class="subscription-dialog-subheader">
        <h3>
          <strong>Your free trial expires in {{ props.daysLeft }} days</strong>
        </h3>
      </div>
    </template>

    <template #content>
      <div class="subscription-dialog-content">
        <p>Your free trial will expire soon. Upgrade now to keep access to all features without interruption.</p>
      </div>
    </template>

    <template #footer>
      <div class="subscription-dialog-footer">
        <v-btn class="dialog-button" variant="outlined" color="secondary" @click="remindLater"> Remind me later </v-btn>

        <v-btn-dialog-action-CTA
          class="dialog-button"
          data-testid="endingSubscriptionDialog.upgrade-button"
          color="primary"
          @click="upgrade"
        >
          Upgrade now
        </v-btn-dialog-action-CTA>
      </div>
    </template>
  </base-dialog>
</template>

<script setup lang="ts">
import BaseDialog from "../shared/BaseDialog.vue";

const emit = defineEmits(["continue"]);

const props = defineProps<{
  daysLeft: number;
}>();

function upgrade() {
  window.open("https://www.itemis.com/en/products/itemis-create/licenses/");
  emit("continue");
}

function remindLater() {
  //TODO
  emit("continue");
}
</script>

<style scoped>
.subscription-dialog-subheader {
  text-align: center;
  margin-top: 10px;
}

.subscription-dialog-content {
  padding: 10px;
  font-size: 14px;
  color: #444;
  text-align: center;
}

.subscription-dialog-footer {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 16px 0;
  gap: 12px;
  width: 100%;
}

.dialog-button {
  flex: 1;
  max-width: 200px;
  min-width: 150px;
}
</style>
